import { AppState } from '../types';

export const DefaultState: AppState = {
  orders: {},
  promoCodes: {
    promoCodes: [],
  },
  onboarding: null,
};
